<form #form="ngForm" (ngSubmit)="save(form)">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Employee ID-->
    <div class="p-field p-col-12 p-md-12">
      <span class="p-float-label">
        <input pInputText 
               required
               id="entityName" name="entityName"
               class="p-inputtext-sm"
               #entityName="ngModel"
               [(ngModel)]="entity.name"
               [class.field-error]="form.submitted && entityName.invalid" />
        <label for="entityName" class="required-field">Enter New {{categoryName}} Here</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && entityName.invalid">{{categoryName}} name is required!</small>
    </div>
  </div> 

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
